<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 14 8"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.9999 1L6.99988 7L0.999878 0.999999" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronDown',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
